import React, { FC, useEffect, useState } from "react";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Dropdown, Layout, theme as antTheme } from "antd";
import { useNavigate } from "react-router-dom";
import logo from "../../asset/HOMELAND_Logowhite.png";
import { MainColor } from "../../components/core/variable/variable";
import UserInfoModal from "../../components/core/modal/modalUserInfo";
import { UserInterface } from "../../interface/user.interface";

const { Header } = Layout;

interface HeaderProps {
  collapsed: boolean;
}

type Action = "userInfo" | "userSetting" | "logout";

const HeaderComponent: FC<HeaderProps> = ({ collapsed }) => {
  const navigate = useNavigate();
  const token = antTheme.useToken();
  const device: any = "Desktop";
  const logged = true;
  const [showUserInfo, setShowUserInfo] = useState(false);
  const [user, setUser] = useState<UserInterface | null>(null);

  const onActionClick = async (action: Action) => {
    switch (action) {
      case "userInfo":
        return;
      case "userSetting":
        return;
      case "logout":
        // const res = Boolean(await dispatch(logoutAsync()));
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        navigate("/login");

        return;
    }
  };

  const toLogin = () => {
    navigate("/login");
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  return (
    <>
      <Header
        className="layout-page-header bg-2"
        style={{
          backgroundColor: MainColor,
          display: "flex",
          justifyContent: "space-between",
        }}>
        {device !== "MOBILE" && (
          <div className="logo" style={{ width: collapsed ? 80 : 200 }}>
            <img
              src={logo}
              alt="logo"
              style={{
                marginRight: collapsed ? "2px" : "20px",
                width: "100px",
                height: "60px",
              }}
            />
          </div>
        )}

        <div className="layout-page-header-main">
          <div className="actions">
            {logged ? (
              <Dropdown
                menu={{
                  items: [
                    {
                      key: "1",
                      icon: <UserOutlined />,
                      label: (
                        <span onClick={() => setShowUserInfo(true)}>
                          Tài khoản
                        </span>
                      ),
                    },
                    {
                      key: "2",
                      icon: <LogoutOutlined />,
                      label: (
                        <span onClick={() => onActionClick("logout")}>
                          Đăng xuất
                        </span>
                      ),
                    },
                  ],
                }}>
                <span>
                  <img
                    src="https://static.vecteezy.com/system/resources/thumbnails/005/545/335/small/user-sign-icon-person-symbol-human-avatar-isolated-on-white-backogrund-vector.jpg"
                    className="user-avator"
                    alt="avatar"
                    width={45}
                    style={{
                      borderRadius: "50%",
                      marginTop: "12px",
                      cursor: "pointer",
                    }}
                  />
                </span>
              </Dropdown>
            ) : (
              <span style={{ cursor: "pointer" }} onClick={toLogin}></span>
            )}
          </div>
        </div>
      </Header>
      <UserInfoModal
        open={showUserInfo}
        onClose={() => setShowUserInfo(false)}
        user={user}
      />
    </>
  );
};

export default HeaderComponent;
